import { useQuery } from 'react-query'

import { API_ENDPOINTS } from 'config/api'
import axios from 'config/axios'

import {
  CertificateApiResponse,
  CertificateData,
  CertificateDataWithLink,
  UserCertificatesApiResponse
} from './certificate.types'

export const fetchCertificate = async (cuid: string) => {
  const response = await axios.get(`${API_ENDPOINTS.CERTIFICATE}/${cuid}`)
  const data = response.data as CertificateApiResponse
  return {
    ...data.data.attributes,
    link: window.location.href
  }
}

export const useCertificate = (cuid: string) => {
  return useQuery<CertificateDataWithLink, null>(
    ['certificate', { cuid }],
    () => fetchCertificate(cuid),
    {
      enabled: !!cuid
    }
  )
}

export const fetchUserCertificates = async (user_id: number) => {
  const response = await axios.get(
    `${API_ENDPOINTS.USER_CERTIFICATE.replace('[user_id]', user_id.toString())}`
  )

  const data = response.data as UserCertificatesApiResponse

  return data.data.attributes.certificates
}

export const useUserCertificates = (user_id: number) => {
  return useQuery<CertificateData[], null>(
    ['user-certificates', { user_id }],
    () => fetchUserCertificates(user_id),
    {
      enabled: !!user_id
    }
  )
}
